import {
  FC,
  useState,
  Fragment,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import { IPays } from "../content/parametrage/Pays/Pays";
import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Stack,
  styled,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useStyles } from "./styles";
import { AlertType } from "../../types/AlertType";
import { UserManagerOperationInterface } from "../content/parametrage/MangerOperation/UserManagerOperationInterface";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import ClearIcon from "@mui/icons-material/Clear";
import CheckAttr from "../../utils/CheckAttr";
import { AxiosInstance } from "axios";
import { DataRef } from "../../types/DataRef";
import { ClientWithOperations } from "../content/parametrage/MangerOperation/ManagerOperation";
interface ManagerOperationFormProps {
  row?: UserManagerOperationInterface;
  dataRefPaysBu: IPays[];
  // clientWithOperations: ClientWithOperations[];
  http: AxiosInstance;
  onClose: () => void;
  handleRefresh: () => void;
  setOpenSnack: Dispatch<SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<SetStateAction<string>>;
  setAlertType: Dispatch<SetStateAction<AlertType>>;
}

interface InputValidation {
  pays: boolean;
  manager: boolean;
}

interface InputValidationCouple {
  index?: number;
  client: boolean;
  operation: boolean;
}

const resetInpuValidation: InputValidation = {
  pays: false,
  manager: false,
};

export interface IManagerUser {
  id: number;
  name: string;
  email: string;
  updated_password: number;
  prenom: string;
  Departement: string;
  pays: string;
  actif: string;
  profil_user_id: number;
}

interface CoupleClientOperation {
  client?: number;
  operation?: number;
  operationsDatas?: DataRef[];
}

interface ManagerOperationToSave {
  pays?: number[];
  user?: number;
  coupleClientOperations: CoupleClientOperation[];
}

const initialManagerOperationToSave: ManagerOperationToSave = {
  pays: [],
  user: undefined,
  coupleClientOperations: [
    {
      client: undefined,
      operation: undefined,
      operationsDatas: [],
    },
  ],
};

const initialForCoupleInput: InputValidationCouple = {
  index: undefined,
  client: false,
  operation: false,
};

const ManagerOperationForm: FC<ManagerOperationFormProps> = ({
  row,
  dataRefPaysBu,
  // clientWithOperations,
  onClose,
  http,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  handleRefresh,
}) => {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isClickSave, setIsClickSave] = useState<boolean>(false);
  const [openSelectMultiple, setOpenSelectMultiple] = useState<boolean>(false);

  const [managersDatas, setManagersDatas] = useState<IManagerUser[]>([]);

  const [indexNotValidate, setIndexNotValidate] = useState<number | undefined>(
    undefined
  );
  const [indexHasDouble, setIndexHasDouble] = useState<number[]>([]);

  const [dataClients, setDataClients] = useState<DataRef[]>([]);
  const [managerOperationToSave, setManagerOperationToSave] =
    useState<ManagerOperationToSave>(initialManagerOperationToSave);

  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);
  const [errorForCoupleInput, setErrorForCoupleInput] =
    useState<InputValidationCouple>(initialForCoupleInput);

  const [clientWithOperations, setClientWithOperations] = useState<
    ClientWithOperations[]
  >([]);

  const getManagersDatas = async (pays: any) => {
    await http
      .post("user/find-manager-via-multi-pays", { pays })
      .then((res) => {
        Array.isArray(res.data) && setManagersDatas(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getClientsDatas = async (pays: any) => {
    await http
      .post("client/get-via-multi-pays", { pays })
      .then((res) => {
        Array.isArray(res.data) && setDataClients(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDefaultManagerOperationToSave = () => {
    const managersPays = row?.pays?.map((item) => item?.id);

    /**
     * Récupère les Managers et Clients
     */
    if (CheckAttr(managersPays)) {
      getManagersDatas(managersPays);
      getClientsDatas(managersPays);
    }

    const defaultCouplesClientOperation: CoupleClientOperation[] = [];
    for (const couple of row?.manager_operation!) {
      const client = couple?.operations?.clients_id;
      const operation = couple?.operation_id;

      defaultCouplesClientOperation.push({
        client,
        operation: operation,
        operationsDatas: clientWithOperations?.find(
          (elem) => elem?.id === client
        )?.operations,
      });
    }

    setManagerOperationToSave({
      ...managerOperationToSave,
      pays: managersPays,
      user: row?.id,
      coupleClientOperations: defaultCouplesClientOperation,
    });
  };

  useEffect(() => {
    /**
     * On rempli déja les champs pour le modification
     */
    if (row) {
      setDefaultManagerOperationToSave();
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }

    return () => {
      setManagerOperationToSave(initialManagerOperationToSave);
    };
  }, []);

  useEffect(() => {
    // Get Operation Par Pays Selectionner
    const RequestAPI = {
      arrayIdPays: managerOperationToSave?.pays,
    };
    if (managerOperationToSave?.pays?.length !== 0) {
      setIsClickSave(true);
      http
      .post(`client/get-with-operation-by-multi-pays`, RequestAPI)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setClientWithOperations(res.data);
          const defaultCouplesClientOperation: CoupleClientOperation[] = [];
          for (const couple of row?.manager_operation!) {
            const client = couple?.operations?.clients_id;
            const operation = couple?.operation_id;

            const idOperationDuClient = res.data?.find(
              (elem) => elem?.id === client
            )?.operations?.map((op:DataRef) => op?.id);

            idOperationDuClient?.includes(operation) && defaultCouplesClientOperation.push({
              client,
              operation: operation,
              operationsDatas: res.data?.find(
                (elem) => elem?.id === client
              )?.operations,
            });
          }

          setManagerOperationToSave({
            ...managerOperationToSave,
            coupleClientOperations: defaultCouplesClientOperation,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {setIsClickSave(false);});
    }
  }, [managerOperationToSave?.pays]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setManagerOperationToSave({
      ...managerOperationToSave,
      [name]: value,
    });
  };

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);

    if (
      !CheckAttr(managerOperationToSave?.pays) ||
      !CheckAttr(managerOperationToSave?.user)
    ) {
      if (!CheckAttr(managerOperationToSave?.pays)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          pays: true,
        }));
      }

      if (!CheckAttr(managerOperationToSave?.user)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          manager: true,
        }));
      }

      setAlerteMessage("Merci de remplir les champs en obligatoire !");
      setAlertType("warning");
      setOpenSnack(true);
      return false;
    }

    return true;
  };

  console.log(managerOperationToSave);

  /**
   * On verifie si au moins il y a une ligne po
   */
  const hasAtLeastOneCoupleClientOperation = (): boolean => {
    const tabToCreate: CoupleClientOperation[] = [];
    for (
      let index = 0;
      index < managerOperationToSave?.coupleClientOperations.length;
      index++
    ) {
      const row = managerOperationToSave?.coupleClientOperations[index];

      if (CheckAttr(row?.client) || CheckAttr(row?.operation)) {
        tabToCreate.push(row);
      }
    }

    if (tabToCreate.length === 0) {
      setAlerteMessage(
        "Merci d'ajouter au moins un couple Client - Opération !"
      );
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }

    return true;
  };

  const cleanData = (): ManagerOperationToSave | boolean => {
    let finalData: ManagerOperationToSave | boolean = false;
    const tabCouples: CoupleClientOperation[] = [];

    const identifiantArray: string[] = [];
    let notValidate = undefined;
    let errorForCouple = false;

    for (
      let index = 0;
      index < managerOperationToSave?.coupleClientOperations.length;
      index++
    ) {
      const row = managerOperationToSave?.coupleClientOperations[index];

      /**
       * Premier verification: Si client - operation sont rempli pour chaque ligne
       */
      if (CheckAttr(row?.client) && CheckAttr(row?.operation)) {
        /**
         * Deuxieme verification: Pour le doublons, si couple client - operation ne se repète pas
         */
        const identifiant = `${row?.client} - ${row?.operation}`;
        if (!identifiantArray.includes(identifiant)) {
          tabCouples.push({
            client: row?.client,
            operation: row?.operation,
          });

          identifiantArray.push(identifiant);
        } else {
          const customer = dataClients.find(
            (elem) => Number(elem?.id) === Number(row?.client)
          )?.libelle;
          const operation = row?.operationsDatas?.find(
            (elem) => Number(elem?.id) === Number(row?.operation)
          )?.libelle;

          const message = `Le couple ${customer} - ${operation} existe déja pour ce manager !`;
          setAlerteMessage(message);
          setAlertType("warning");
          setOpenSnack(true);
          notValidate = index;
          break;
        }
      } else {
        if (!CheckAttr(row?.client)) {
          setErrorForCoupleInput((prev: InputValidationCouple) => ({
            ...prev,
            index,
            client: true,
          }));
        }

        if (!CheckAttr(row?.operation)) {
          setErrorForCoupleInput((prev: InputValidationCouple) => ({
            ...prev,
            index,
            operation: true,
          }));
        }

        errorForCouple = true;
        setAlerteMessage("Veuillez remplir le(s) champ(s) en rouge SVP !");
        setAlertType("warning");
        setOpenSnack(true);
        break;
      }
    }

    if (!CheckAttr(notValidate) && !CheckAttr(errorForCouple)) {
      if (tabCouples.length > 0) {
        finalData = {
          pays: managerOperationToSave?.pays,
          user: managerOperationToSave?.user,
          coupleClientOperations: tabCouples,
        };
      }
    } else {
      setIndexNotValidate(notValidate);
    }

    return finalData;
  };

  const handleSave = () => {
    setIndexNotValidate(undefined);
    setIndexHasDouble([]);
    setErrorForCoupleInput(initialForCoupleInput);

    /**
     * Verification 1er niveau
     */
    if (isValidate()) {
      /**
       * Vérification qu'au moins un couple client-operation saisi
       */
      if (hasAtLeastOneCoupleClientOperation()) {
        setIsClickSave(true);

        /**
         * Validation de tous les couples saisie
         * Est-ce qu'ils sont tous rempli (client et operation)
         * Verification s'il y a des doublons
         */
        const datas = cleanData();
        if (CheckAttr(datas)) {
          if (row) {
            /**
             * Pour le cas UPDATE
             * On passe directement à la mis à jour
             */
            http
              .put("manager-operation/update", datas)
              .then(() => {
                setAlerteMessage("Mis à jour effectué aves succès !");
                setAlertType("success");
                setOpenSnack(true);
                onClose();
                handleRefresh();
              })
              .catch((error) => {
                console.log(error);
                setAlertType("error");
                setOpenSnack(true);
              })
              .finally(() => {
                setIsClickSave(false);
              });
          } else {
            /**
             * Pour le cas AJOUT
             * On verifie d'abord l'unicité de chaque couple client-operation au niveau BACK
             * Si OK, on passe à l'enregistrement
             * Dans le cas contraire, on alerte l'utilisateur
             */
            http
              .post("manager-operation/check-unicity", datas)
              .then((res) => {
                const { isExist, indexes } = res?.data;

                if (!isExist) {
                  // Enregistremnt
                  http
                    .post("manager-operation/save", datas)
                    .then(() => {
                      setAlerteMessage("Enregistrement effectué aves succès !");
                      setAlertType("success");
                      setOpenSnack(true);
                      onClose();
                      handleRefresh();
                    })
                    .catch((error) => {
                      console.log(error);
                      setAlertType("error");
                      setOpenSnack(true);
                    })
                    .finally(() => {
                      setIsClickSave(false);
                    });
                } else {
                  // on alerte l'utilisateur s'il y a des doublons dans la base
                  setIndexHasDouble(indexes);
                  setAlerteMessage(
                    "Le(s) couple(s) Client - Opération en rouge existe(nt) déjà !"
                  );
                  setAlertType("warning");
                  setOpenSnack(true);
                  setIsClickSave(false);
                }
              })
              .catch((error) => {
                console.log(error);
                setIsClickSave(false);
                setAlertType("error");
                setOpenSnack(true);
              });
          }
        } else {
          setIsClickSave(false);
        }
      }
    }
  };

  const handleChangeRow = (index: number, e: any) => {
    const { name, value } = e.target;
    const values = [...managerOperationToSave?.coupleClientOperations];

    if (name === "client") {
      values[index].client = value;

      if (value) {
        // On assigne le client et recupères les operation du client
        values[index].operationsDatas = clientWithOperations?.find(
          (elem) => elem?.id === Number(value)
        )?.operations;

        setManagerOperationToSave({
          ...managerOperationToSave,
          coupleClientOperations: values,
        });
      } else {
        values[index].operationsDatas = [];
      }
    }

    if (name === "operation") {
      values[index].operation = value;

      setManagerOperationToSave({
        ...managerOperationToSave,
        coupleClientOperations: values,
      });
    }
  };

  const handleAddRow = () => {
    const tmpCoupleClientOperations =
      managerOperationToSave?.coupleClientOperations;

    tmpCoupleClientOperations.push({
      client: undefined,
      operation: undefined,
      operationsDatas: [],
    });

    setManagerOperationToSave({
      ...managerOperationToSave,
      coupleClientOperations: tmpCoupleClientOperations,
    });
  };

  const handleRemoveRow = (index: any) => {
    const tempArray = [...managerOperationToSave?.coupleClientOperations];

    tempArray.splice(index, 1);
    setManagerOperationToSave({
      ...managerOperationToSave,
      coupleClientOperations: tempArray,
    });
  };

  const clientError = (index: number): boolean => {
    if (indexNotValidate === index) {
      return true;
    }

    if (errorForCoupleInput?.index === index && errorForCoupleInput?.client) {
      return true;
    }

    if (indexHasDouble.includes(index)) {
      return true;
    }

    return false;
  };

  const operationError = (index: number): boolean => {
    if (indexNotValidate === index) {
      return true;
    }

    if (
      errorForCoupleInput?.index === index &&
      errorForCoupleInput?.operation
    ) {
      return true;
    }

    if (indexHasDouble.includes(index)) {
      return true;
    }

    return false;
  };

  const handleCloseSelectMulti = () => {
    setOpenSelectMultiple((prev) => !prev);
  };

  const handleChangeSelectMultitple = (e: any) => {
    const { value } = e.target;
    e.stopPropagation();
    setIndexNotValidate(undefined);
    setIndexHasDouble([]);
    setErrorForCoupleInput(initialForCoupleInput);
    setManagersDatas([]);
    setDataClients([]);
    handleCloseSelectMulti();

    setManagerOperationToSave((prev) => ({
      ...prev,
      pays: value,
      user: undefined,
      coupleClientOperations: [
        {
          client: undefined,
          operation: undefined,
          operationsDatas: [],
        },
      ],
    }));

    if (CheckAttr(value)) {
      // Recupère les utilisateurs pour le champ manager
      getManagersDatas(value);

      // Recupère les clients pour le champ client
      getClientsDatas(value);
    }
  };

  /**
   * Logique page loading...........................
   */
  const progress = (
    <div className={classes.loading}>
      <LinearProgress color="error" sx={{ my: 2 }} />
      <LinearProgress color="warning" />
    </div>
  );

  const formContent = (
    <Fragment>
      <Box className={classes.root}>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
          <Grid item xs={5.5} sm={5.5} md={5.5}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                htmlFor="profil-contact"
                color="warning"
                shrink={true}
              >
                Pays
              </InputLabel>
              <Select
                open={openSelectMultiple}
                onClick={() => handleCloseSelectMulti()}
                multiple
                error={errorInput.pays}
                displayEmpty
                value={managerOperationToSave?.pays}
                onChange={handleChangeSelectMultitple}
                renderValue={(selected) => {
                  return (
                    <div className={classes.chips}>
                      {((selected as number[]) || []).map((value) => (
                        <Chip
                          key={value}
                          label={
                            dataRefPaysBu.find((item) => item.id === value)
                              ?.libelle
                          }
                          className={classes.chip}
                        />
                      ))}
                    </div>
                  );
                }}
                label="Pays"
                color="warning"
                inputProps={{
                  name: "pays",
                  id: "pays",
                }}
                MenuProps={{
                  sx: {
                    "&& .Mui-selected": {
                      backgroundColor: "#080d24",
                      color: "#fff",
                    },
                  },
                }}
              >
                <MenuItem disabled value="" dense></MenuItem>
                {dataRefPaysBu.map((pays) => (
                  <MenuItem
                    key={pays.id}
                    value={pays.id}
                    onClick={() => handleCloseSelectMulti()}
                    dense
                  >
                    {pays.libelle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={5.5} sm={5.5} md={5.5}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="user"
                color="warning"
                shrink={CheckAttr(managerOperationToSave?.user)}
              >
                Manager
              </InputLabel>
              <Select
                native
                color="warning"
                error={errorInput?.manager}
                value={managerOperationToSave?.user}
                onChange={handleChange}
                label="Manager"
                inputProps={{
                  name: "user",
                }}
              >
                <option value=""></option>
                {managersDatas.map((manager) => (
                  <option key={manager?.id} value={manager?.id}>
                    {manager?.prenom} {manager?.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }} mt={5}>
          {managerOperationToSave?.coupleClientOperations.map((row, index) => (
            <Fragment key={index}>
              <Grid item xs={5.5} sm={5.5} md={5.5}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  sx={{ marginLeft: 1, marginTop: 1 }}
                >
                  <InputLabel
                    htmlFor="client"
                    color="warning"
                    shrink={CheckAttr(row?.client)}
                  >
                    Client
                  </InputLabel>
                  <Select
                    id="client"
                    native
                    color="warning"
                    // disabled={row?.hasArticles}
                    error={clientError(index)}
                    value={row?.client}
                    onChange={(e) => handleChangeRow(index, e)}
                    label="Client"
                    inputProps={{
                      name: "client",
                    }}
                  >
                    <option value=""></option>
                    {dataClients.map((client) => (
                      <option key={client?.id} value={client?.id}>
                        {client?.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={5.5} sm={5.5} md={5.5}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  sx={{ marginLeft: 1, marginTop: 1 }}
                >
                  <InputLabel
                    htmlFor="operation"
                    color="warning"
                    shrink={CheckAttr(row?.operation)}
                  >
                    Opération
                  </InputLabel>
                  <Select
                    id="operation"
                    native
                    color="warning"
                    // disabled={row?.hasArticles}
                    error={operationError(index)}
                    value={row?.operation}
                    onChange={(e) => handleChangeRow(index, e)}
                    label="Opération"
                    inputProps={{
                      name: "operation",
                    }}
                  >
                    <option value=""></option>
                    {managerOperationToSave?.coupleClientOperations[
                      index
                    ]?.operationsDatas?.map((operation) => (
                      <option key={operation?.id} value={operation?.id}>
                        {operation?.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                <Box display="flex" justifyContent="end" mt={2}>
                  <Button
                    variant="text"
                    size="small"
                    // disabled={row?.hasArticles}
                    onClick={() => handleRemoveRow(index)}
                  >
                    <ClearIcon
                      sx={{
                        fontSize: 26,
                        // color: row?.hasArticles ? "#D6D6DA" : "#000",
                        color: "#000",
                      }}
                    />
                  </Button>
                </Box>
              </Grid>
            </Fragment>
          ))}
          <Stack
            direction="row"
            spacing={2}
            display="flex"
            justifyContent="start"
            mt={2}
          >
            <Button
              variant="contained"
              color="inherit"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => handleAddRow()}
              style={{ textTransform: "none", color: "#080d24" }}
            >
              Affecter nouvelle opération
            </Button>
          </Stack>
        </Grid>
      </Box>
      <Box display="flex" justifyContent="center" mt={5}>
        <LoadingButton
          onClick={() => handleSave()}
          endIcon={<SaveIcon />}
          loading={isClickSave}
          loadingPosition="end"
          sx={{ textTransform: "none" }}
          variant="contained"
          color="warning"
        >
          Enregistrer
        </LoadingButton>
      </Box>
    </Fragment>
  );

  const content = isLoading ? progress : formContent;

  return content;
};

export default ManagerOperationForm;
